export default "__VITE_ASSET__DBXbJIQc__"